// extracted by mini-css-extract-plugin
var _1 = "RiskBannerStyle-module__closeBtn___PsoJ2";
var _2 = "RiskBannerStyle-module__riskBanner___pwfEO";
export { _1 as "closeBtn", _2 as "riskBanner" }
